import React, { useMemo, useState } from 'react';
import { PLACEHOLDER_JOBS, JOB_FILTERS, ROUTES } from '../data/content';
import ScrollReveal from '../components/ScrollReveal';
import MagneticButton from '../components/MagneticButton';
import JobCard from '../components/JobCard';

/* ==================================================================
   OpportunityShowcase
   ------------------------------------------------------------------
   An interactive preview of the board. The filter chips are the only
   piece of real state on the page; changing one re-keys the grid so
   the surviving cards replay their entrance stagger.

   `jobs` is a prop so this section can be handed a live feed later
   without any change here.
   ================================================================== */

export default function OpportunityShowcase({ jobs = PLACEHOLDER_JOBS }) {
  const [filter, setFilter] = useState('all');

  const visible = useMemo(
    () => (filter === 'all' ? jobs : jobs.filter((job) => job.mode === filter)),
    [filter, jobs]
  );

  return (
    <section id="opportunities" className="hs-board">
      <div className="hs-shell">
        <header className="hs-board__head">
          <div>
            <ScrollReveal as="p" className="hs-eyebrow">Live board preview</ScrollReveal>
            <ScrollReveal as="h2" className="hs-h2" delay={80}>
              Opportunities worth applying for.
            </ScrollReveal>
          </div>
          <ScrollReveal className="hs-board__filters" delay={140} variant="fade">
            {JOB_FILTERS.map((chip) => (
              <button
                key={chip.id}
                type="button"
                className={`hs-chip ${filter === chip.id ? 'is-active' : ''}`}
                onClick={() => setFilter(chip.id)}
                aria-pressed={filter === chip.id}
              >
                {chip.label}
              </button>
            ))}
          </ScrollReveal>
        </header>

        <div className="hs-board__grid" key={filter}>
          {visible.map((job, i) => (
            <ScrollReveal key={job.id} delay={i * 90} variant="up">
              <JobCard job={job} index={i} applyTo={ROUTES.studentSignup} />
            </ScrollReveal>
          ))}
          {visible.length === 0 && (
            <p className="hs-board__empty">No sample roles in this mode yet.</p>
          )}
        </div>

        <ScrollReveal className="hs-board__foot" variant="fade" delay={120}>
          <p>Sample roles shown for preview. Sign in to see every live opening.</p>
          <MagneticButton to={ROUTES.studentSignup} variant="soft" size="md" arrow>
            Browse all opportunities
          </MagneticButton>
        </ScrollReveal>
      </div>
    </section>
  );
}
